import create from "zustand";
import { PostInfo } from "../components/Cafe/types";
import { VoidReducer } from "./types";

interface CafeViewStore {
  rows: PostInfo[];
  setRows: VoidReducer;
}

export const useCafeViewStore = create<CafeViewStore>((set) => ({
  rows: [],
  setRows: (rows) => set({ rows }),
}));
